import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import { Setting, Subscription } from '../App';

export const useSubscriptionCancel = (setting: Setting) => {
  const subscriptionCancel = (success: () => void, failed?: (message: string) => void) => {
    (async () => {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = response.data.filter((subscription: Subscription) => subscription.status === 'ACTIVE');
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0] as Subscription;

        await axios.post(
          `${CUSTOMER_API_URL}?action=updateSubscription`,
          {
            subscriptionId: subscription.subscriptionContractId,
            status: 'cancelled',
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    subscriptionCancel,
  };
};
